export const PASSWORD_RECOVERY_FLAG = 'supabase_password_recovery';

export function markPasswordRecovery() {
  sessionStorage.setItem(PASSWORD_RECOVERY_FLAG, '1');
}

export function clearPasswordRecovery() {
  sessionStorage.removeItem(PASSWORD_RECOVERY_FLAG);
}

/** True while user is in the password-reset flow (survives after Supabase strips URL hash). */
export function isPasswordRecoveryActive() {
  if (sessionStorage.getItem(PASSWORD_RECOVERY_FLAG) === '1') {
    return true;
  }
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const search = new URLSearchParams(window.location.search);
  return hash.get('type') === 'recovery' || search.get('type') === 'recovery';
}

/** Logged-in user opened "Keisti slaptažodį" (/auth?view=update_password). */
export function isUpdatePasswordAuthRoute() {
  if (window.location.pathname !== '/auth') {
    return false;
  }
  return new URLSearchParams(window.location.search).get('view') === 'update_password';
}

/** Call as early as possible on load — Supabase may clear the hash right after parse. */
export function captureRecoveryFromUrl() {
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const search = new URLSearchParams(window.location.search);
  if (hash.get('type') === 'recovery' || search.get('type') === 'recovery') {
    markPasswordRecovery();
    return true;
  }
  return false;
}
